import { createStore, useStore } from "zustand";
import { persist } from "zustand/middleware";
// import { MultiLangValueType } from "helpers/functions";
import { strapiApi, strapiBaseUrl } from "shared/api/strapi";

export interface IStory {
  id: number;
  locale: string;
  sort_id: number;
  created_at: string;
  is_active: boolean;
  title: string;
  image: string;
  items: Array<{
    id: number;
    sort_id: number;
    title: string;
    content: string;
    image: string;

    action_btn: {
      text?: string;
      link?: string;
      params?: string;
    };

    disclaimer: {
      text?: string;
      link?: string;
    };
  }>;
}

type StrapiState = {
  stories: IStory[];
  storiesWatched: number[];
  setStoriesWatched: (id: number) => void;
  loadStories: (userId: number, isIndividual: boolean) => Promise<void>;
};

const STRAPI_ORIGIN = (() => {
  try {
    return new URL(strapiBaseUrl).origin;
  } catch {
    return "";
  }
})();

const toAbsoluteUrl = (url: string) =>
  !url || url.startsWith("http")
    ? url
    : `${STRAPI_ORIGIN}${url.startsWith("/") ? url : `/${url}`}`;

const extractMediaUrl = (image: any): string => {
  if (!image) return "";
  if (typeof image === "string") return toAbsoluteUrl(image);
  const url =
    image?.url ??
    image?.data?.attributes?.url ??
    image?.data?.[0]?.attributes?.url;
  return typeof url === "string" ? toAbsoluteUrl(url) : "";
};

const normalizeStory = (raw: any): IStory => {
  const s = raw?.attributes ? { id: raw.id, ...raw.attributes } : raw;
  return {
    ...s,
    image: extractMediaUrl(s.image),
    items: (s.items ?? []).map((item: any) => ({
      ...item,
      image: extractMediaUrl(item.image),
    })),
  };
};

export const strapiStore = createStore<StrapiState>()(
  persist(
    (set, get) => ({
      stories: [],
      storiesWatched: [],
      setStoriesWatched: (id: number) => {
        set({
          storiesWatched: Array.from(new Set([...get().storiesWatched, id])),
        });
      },
      loadStories: async (userId: number, isIndividual: boolean) => {
        try {
          const resp = await strapiApi.stories(userId, isIndividual);

          if (resp.error) {
            return;
          }

          const rawStories = (resp.data?.data || []) as any[];

          // console.log("Raw stories:", rawStories);x

          // const stories = rawStories.map((item) => {
          //   const attrs = item?.attributes || {};
          //   return {
          //     id: item.id,
          //     ...attrs,
          //   } as IStory;
          // });

          set({ stories: rawStories.map(normalizeStory) });
        } catch (error) {
          console.log(error);
        }
      },
    }),
    {
      name: "strapi",
      version: 1,
      merge: (persistedState, currState) => {
        const { storiesWatched } = persistedState as Partial<StrapiState>;

        return {
          ...currState,
          storiesWatched: storiesWatched || [],
        };
      },
    },
  ),
);

export const useStrapiStories = () =>
  useStore(strapiStore, (state) => state.stories);
